module.exports = __webpack_public_path__ + "dbc6993188bbdaf3272644464584241b.svg";